import { useState } from "react";
const Logo = require("../assets/logo2.jpg");

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsMenuOpen(false); // Close mobile menu after clicking
  };

  return (
    <header className="bg-base shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          {/* Logo Section */}
          <div className="flex items-center">
            <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
              <img
                src={Logo}
                alt="PneuBot Logo"
                className="w-16 h-16 rounded object-contain"
              />
              <span className="ml-3 text-xl font-bold text-white">Life Missions</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-2 lg:space-x-4">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-white hover:bg-hoverbase px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-white hover:bg-hoverbase px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
            >
              Who We Are
            </button>
            <button 
              onClick={() => scrollToSection('focus')}
              className="text-white hover:bg-hoverbase px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
            >
              Focus Areas
            </button>
            <button 
              onClick={() => scrollToSection('impact')}
              className="text-white hover:bg-hoverbase px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
            >
              Impact
            </button>
            <button 
              onClick={() => scrollToSection('get-involved')}
              className="text-white hover:bg-hoverbase px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
            >
              Get Involved
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-white hover:bg-hoverbase px-4 py-2 rounded-md text-sm font-medium transition-colors duration-300"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-hoverbase focus:outline-none transition-colors duration-300"
              aria-expanded={isMenuOpen}
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? (
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden px-2 pt-2 pb-3 space-y-2">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-4 py-3 rounded-md text-base font-medium text-white hover:bg-hoverbase transition-colors duration-300"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-3 rounded-md text-base font-medium text-white hover:bg-hoverbase transition-colors duration-300"
            >
              Who We Are
            </button>
            <button
              onClick={() => scrollToSection('focus')}
              className="block w-full text-left px-4 py-3 rounded-md text-base font-medium text-white hover:bg-hoverbase transition-colors duration-300"
            >
              Focus Areas
            </button>
            <button
              onClick={() => scrollToSection('impact')}
              className="block w-full text-left px-4 py-3 rounded-md text-base font-medium text-white hover:bg-hoverbase transition-colors duration-300"
            >
              Impact
            </button>
            <button
              onClick={() => scrollToSection('get-involved')}
              className="block w-full text-left px-4 py-3 rounded-md text-base font-medium text-white hover:bg-hoverbase transition-colors duration-300"
            >
              Get Involved
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-3 rounded-md text-base font-medium text-white hover:bg-hoverbase transition-colors duration-300"
            >
              Contact
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;